import React from 'react';
import { Icon } from './Icon.js';
export const IconMoveObjUpLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M4.561,3.5h2.7c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75H2.75c-.414,0-.75,.336-.75,.75V7.26c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-2.7l3.72,3.72c.146,.146,.338,.22,.53,.22s.384-.073,.53-.22c.293-.293,.293-.768,0-1.061l-3.72-3.72Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "9", y: "9", width: "7", height: "7", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconMoveObjUpLeftFill18.js.map